import { ExlyInput } from "common/form";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { SubSectionText } from "features/AdminPanel/modules/SubSectionText/SubSectionText";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { getSectionStates } from "features/AdminPanel/modules/utils/AdminPanel.utils";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { checkIsStringEmpty } from "features/Common/modules/DataTypes/Strings.utils";
import { checkIsObjectEmpty } from "features/Common/modules/DataTypes/utils/object";
import React, { useEffect, useState } from "react";
import ExlyLoader from "ui/modules/ExlyLoader";
import {
  MAX_DEVICE_LIMIT,
  MIN_DEVICE_LIMIT,
} from "./DeviceManagement.constants";

export const DeviceManagementSubSection = (props) => {
  const { subsectionKey } = props;
  const isDesktop = useDesktopMediaQuery();
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const { handleSectionChange } = useAccountSectionUnlocking();
  const subSectionConfig = sectionConfig[subsectionKey] || {};

  const { value, status } = subSectionConfig;

  const {
    is_multi_login_check,
    multi_login_count,
    multi_login_count_mobile,
    enable_customer_initiated_logouts,
  } = value ?? {};

  const [deviceLimits, setDeviceLimits] = useState(undefined);
  const [errorText, setErrorText] = useState({ web: "", app: "" });

  useEffect(() => {
    if (!checkIsObjectEmpty(value) && deviceLimits === undefined) {
      setDeviceLimits({
        web: multi_login_count,
        app: multi_login_count_mobile,
      });
    }
  }, []);

  if (checkIsObjectEmpty(value)) {
    return <ExlyLoader />;
  }

  const { disableSwitch } = getSectionStates({
    status,
  });

  const handleChange = ({ formKey, formValue }) => {
    const payload = {
      feature_key: subsectionKey,
      feature_value: {
        ...value,
        [formKey]: formValue,
      },
    };

    handleSectionChange({ payload });
  };

  return (
    <div className={`tw-flex tw-flex-col tw-gap-[10px] tw-w-full`}>
      <div className={`tw-flex tw-items-center tw-gap-[8px] md:tw-gap-[48px]`}>
        <SubSectionText
          subSectionConfig={{
            title: isDesktop
              ? "Limit the no. of devices allowed per customer"
              : "Limit number of devices",
            description:
              "Toggle on to set a limit on no. of devices allowed for login per customer, for web and app",
          }}
        />

        <SectionUnlockingSwitch
          value={is_multi_login_check}
          onChange={() =>
            handleChange({
              formKey: "is_multi_login_check",
              formValue: !is_multi_login_check,
            })
          }
          disabled={disableSwitch}
        />
      </div>

      {!isDesktop && (
        <div
          className={`tw-ml-[-16px] tw-mr-[-16px] tw-h-[1px] tw-bg-[#E4E4E4]`}
        ></div>
      )}

      {is_multi_login_check && (
        <>
          <div
            className={`tw-flex tw-items-center tw-gap-[8px] md:tw-gap-[48px] md:tw-flex-row tw-flex-col`}
          >
            <SubSectionText
              subSectionConfig={{
                title: "Set device limits",
                description:
                  "Toggle on to set a limit on no. of devices allowed for login per customer, for web and app",
              }}
            />

            <div className={`tw-flex tw-gap-[5px]`}>
              <div>
                <div
                  className={`tw-text-[12px] tw-font-medium tw-text-[rgba(39,37,34,0.6)] tw-mb-1`}
                >
                  For web
                </div>
                <ExlyInput
                  type="number"
                  helperText={errorText.web}
                  error={!checkIsStringEmpty(errorText?.web)}
                  onChange={(formValue) => {
                    setDeviceLimits({ ...deviceLimits, web: formValue });
                  }}
                  onBlur={(e) => {
                    const formValue = parseInt(e.target.value);
                    if (formValue < MIN_DEVICE_LIMIT) {
                      return setErrorText({
                        ...errorText,
                        web: `Min ${MIN_DEVICE_LIMIT}`,
                      });
                    }
                    if (formValue > MAX_DEVICE_LIMIT) {
                      return setErrorText({
                        ...errorText,
                        web: `Max ${MAX_DEVICE_LIMIT}`,
                      });
                    }
                    if (!checkIsStringEmpty(errorText?.web)) {
                      setErrorText({
                        ...errorText,
                        web: "",
                      });
                    }
                    handleChange({
                      formKey: "multi_login_count",
                      formValue,
                    });
                  }}
                  value={deviceLimits?.web}
                  className={`tw-w-[118px] tw-h-[32px]`}
                />
              </div>
              {/* will be used later when we enable device management in app */}
              {/* <div>
                <div
                  className={`tw-text-[12px] tw-font-medium tw-text-[rgba(39,37,34,0.6)] tw-mb-1`}
                >
                  For app
                </div>
                <ExlyInput
                  type="number"
                  helperText={errorText.app}
                  error={!checkIsStringEmpty(errorText?.app)}
                  onChange={(formValue) => {
                    setDeviceLimits({ ...deviceLimits, app: formValue });
                  }}
                  onBlur={(e) => {
                    const formValue = parseInt(e.target.value);
                    if (formValue < MIN_DEVICE_LIMIT) {
                      return setErrorText({
                        ...errorText,
                        app: `Min ${MIN_DEVICE_LIMIT}`,
                      });
                    }
                    if (formValue > MAX_DEVICE_LIMIT) {
                      return setErrorText({
                        ...errorText,
                        app: `Max ${MAX_DEVICE_LIMIT}`,
                      });
                    }
                    if (!checkIsStringEmpty(errorText?.app)) {
                      setErrorText({
                        ...errorText,
                        app: "",
                      });
                    }
                    handleChange({
                      formKey: "multi_login_count_mobile",
                      formValue,
                    });
                  }}
                  value={deviceLimits?.app}
                  className={`tw-w-[118px] tw-h-[32px]`}
                />
              </div> */}
            </div>
          </div>

          {!isDesktop && (
            <div
              className={`tw-ml-[-16px] tw-mr-[-16px] tw-h-[1px] tw-bg-[#E4E4E4]`}
            ></div>
          )}

          <div
            className={`tw-flex tw-items-center tw-gap-[8px] md:tw-gap-[48px]`}
          >
            <SubSectionText
              subSectionConfig={{
                title: isDesktop
                  ? "Enable customer to view & log out devices"
                  : "Enable customer to logout",
                description:
                  "Toggle on to allow the customer to view a list of all their devices and log themselves out if needed.",
              }}
            />

            <SectionUnlockingSwitch
              value={enable_customer_initiated_logouts}
              onChange={() =>
                handleChange({
                  formKey: "enable_customer_initiated_logouts",
                  formValue: !enable_customer_initiated_logouts,
                })
              }
              disabled={disableSwitch}
            />
          </div>
        </>
      )}
    </div>
  );
};
